import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from "redux-form";
import {resetCurrentForm, setReturnsFilter, fetchCustomerReturnsByFilter, createCustomerReturn, editCustomerReturn, dispatchEditReturn, fetchDispatchReturns, fetchCustomerReturn,
  fetchCustomers, createRMAOrder, editRMAOrder,
} from "../../actions/rma_actions";
import RMAForm from "../../components/RMA/rmaForm";
import { setValue } from '../../actions/sales_actions';
import { setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';

const validate = values => {
    const errors = {}
    if (!values.Customer_Name) {
      errors.Customer_Name = 'Required'
    }
    if (!values.RMA_Content) {
        errors.RMA_Content = 'Required'
    }
    if (!values.RMA_Num) {
        errors.RMA_Num = 'Required'
    }
    if (typeof values.Is_Warranty !== 'boolean' && typeof values.Is_Warranty !== 'object') {
        errors.Is_Warranty = 'Required'
    }
    if (!values.Product_SN) {
        errors.Product_SN = 'Required'
    }
    if (!values.Product_Description) {
        errors.Product_Description = 'Required'
    }
    if (!values.Product_Model) {
        errors.Product_Model = 'Required'
    }
    return errors
}
const rmaForm = reduxForm({
    form: 'rmaForm',
    validate,
    enableReinitialize: true,
})(RMAForm);


const selector = formValueSelector('rmaForm');

function mapStateToProps(state) {
    const RMA_Content = selector(state, 'RMA_Content');
    const RMA_Service_Type = selector(state, 'RMA_Service_Type');
    const RMA_Num = selector(state, 'RMA_Num');
    const Product_SN = selector(state, 'Product_SN');
    const Product_Description = selector(state, 'Product_Description');
    const Return_Logitics_Company = selector(state, 'Return_Logitics_Company');
    const Return_Tracking_Num = selector(state, 'Return_Tracking_Num');
    const Is_Urgent = selector(state, 'Is_Urgent');
    const Is_Warranty = selector(state, 'Is_Warranty');
    const Customer_Name = selector(state, 'Customer_Name');
    const Customer_Mobile = selector(state, 'Customer_Mobile');
    const Customer_Address = selector(state, 'Customer_Address');
    const Customer_Email = selector(state, 'Customer_Email');
    const Submit_Description1 = selector(state, 'Submit_Description1')
    const Submit_Description2 = selector(state, 'Submit_Description2');
    const Openbox_Description = selector(state, 'Openbox_Description');
    const Product_Detail_Info = selector(state, 'Product_Detail_Info');
    const Warehouse_Check_Info = selector(state, 'Warehouse_Check_Info');
    const Fix_Status = selector(state, 'Fix_Status');
    const Fix_Description1 = selector(state, 'Fix_Description1');
    const Fix_Description2 = selector(state, 'Fix_Description2');
    const Dispatch_Logiticis_Company = selector(state, 'Dispatch_Logiticis_Company');
    const Dispatch_Tracking_Num = selector(state, 'Dispatch_Tracking_Num');
    const Dispatch_Fee = selector(state, 'Dispatch_Fee');
    const Dispatch_Date = selector(state, 'Dispatch_Date');
    const Person_Dispatch = selector(state, 'Person_Dispatch');
    const Dispatch_Description1 = selector(state, 'Dispatch_Description1');
    const Dispatch_Description2 = selector(state, 'Dispatch_Description2');
    const Days = selector(state, 'Days');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    const Status = selector(state, 'Status');
    const Customer = selector(state, 'Customer');
    const notesShortcut = selector(state, 'notesShortcut');

    return {
        notesShortcut,
        Days,
        FromDate,
        ToDate,
        Status,
        Dispatch_Logiticis_Company,
        Dispatch_Tracking_Num,
        Dispatch_Fee,
        Dispatch_Date,
        Person_Dispatch,
        Dispatch_Description1,
        Dispatch_Description2,
        RMA_Content,
        RMA_Service_Type,
        RMA_Num,
        Product_SN,
        Product_Description,
        Return_Logitics_Company,
        Return_Tracking_Num,
        Is_Urgent,
        Is_Warranty,
        Customer_Name,
        Customer_Mobile,
        Customer_Address,
        Customer_Email,
        Submit_Description1,
        Submit_Description2,
        Openbox_Description,
        Product_Detail_Info,
        Warehouse_Check_Info,
        Fix_Status,
        Fix_Description1,
        Fix_Description2,
        customerReturns: state.rma.customerReturns,
        dispatchReturns: state.rma.dispatchReturns,
        isLoading: state.rma.isLoading,
        error: state.rma.error,
        customerReturnError: state.rma.customerReturnError,
        dispatchReturnError: state.rma.dispatchReturnError,
        isCreating: state.rma.isCreating,
        createCustomerReturnError: state.rma.createCustomerReturnError,
        created: state.rma.created,
        editCustomerReturnError: state.rma.editCustomerReturnError,
        editDispatchReturnError: state.rma.editDispatchReturnError,
        isEditing: state.rma.isEditing,
        returnsFilter: state.rma.returnsFilter,
        initialValues: state.rma.currentReturnDetail,
        currentReturnDetail: state.rma.currentReturnDetail,
        customerOptions: state.rma.customers.map(customer => ({
          label: customer.Name,
          value: customer.Customer_id,
        })),
        Customer,
    };
}

export default connect(mapStateToProps, {
    fetchCustomerReturnsByFilter, 
    createCustomerReturn, 
    editCustomerReturn, 
    dispatchEditReturn, 
    fetchDispatchReturns,
    setReturnsFilter,
    setValue,
    setDefaultDays,
    setDefaultOfForm,
    resetCurrentForm,
    fetchCustomerReturn,
    fetchCustomers,
    createRMAOrder,
    editRMAOrder,
})(rmaForm);


// WEBPACK FOOTER //
// ./master/jsx/containers/RMA/rmaForm.jsx